var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.sport === 'soccer')?_c('match-page-soccer'):_vm._e(),(_vm.sport === 'hockey')?_c('match-page-hockey'):_vm._e(),(_vm.sport === 'bsktbl')?_c('match-page-basketball'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }